export const environment = {
  production: true
};

export const API_ENDPOINT = 'https://{company}.mychronos.app/api/v1';
// export const API_ENDPOINT = 'https://{company}.ngrok-free.app/api/v1';
export const WEB_APP_URL = 'https://web.mychronos.app';
export const SENTRY_APP_KEY = 'b720e86eba45065e65a806a0faef9488';
export const SENTRY_PROJECT_KEY = '4508879736537168';
